import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: '首页', href: '#hero' },
    { label: '常见问题', href: '#faq' },
    { label: '专题索引', href: '#index' },
    { label: '移动观影', href: '#app' },
    { label: '热门话题', href: '#topics' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-[72px] px-4 md:px-6 max-w-[1440px] mx-auto">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="font-display text-xl md:text-2xl text-foreground-900">春夜影院</span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="flex flex-col px-4 py-3 gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 py-1 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}